import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withAuthUser from 'hoc/withAuthUser';
import styles from 'styles/Layout.module.scss';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useTheme } from 'contexts/ThemeContext';
import { getAllCentresAsync } from 'store/master';
import { CHAT_GROUP_TYPE, USER_STATUS } from 'constants/constants';
import { SELECTED_CENTRES } from 'helpers/storage';
import {
  getCentresList,
  setSelectedCentre,
  getSelectedCentre,
} from 'store/master';

import { isIOS, isMobile } from 'react-device-detect';
import PermissionWrapper from 'components/Permission/permission-wrapper';

import LearningPathModal from 'components/ConfirmationPopup/learningPath-modal';
import AiModalPopup from 'components/ConfirmationPopup/ai-modal';
import useIdleLogout from 'hooks/useIdleLogout';
import ChatbotModal from 'components/ConfirmationPopup/chatbot-modal';

const Layout = ({ children }) => {
  const selectedCentre = useSelector(getSelectedCentre);
  const centreList = useSelector(getCentresList);

  const dispatch = useDispatch();
  useIdleLogout();
  const { pathname } = useRouter();

  const centerRefresh = async () => {
    if (typeof selectedCentre === 'undefined') {
      let vl = await SELECTED_CENTRES.get();
      const value =
        typeof vl !== 'undefined' && vl !== null && vl !== ''
          ? JSON.parse(vl)
          : undefined;
      dispatch(setSelectedCentre(value));
    }
  };

  useEffect(() => {
    if (selectedCentre && centreList?.length) {
      const centreContain = centreList?.some(
        (dt) => dt._id === selectedCentre?._id,
      );

      if (!centreContain) {
        dispatch(setSelectedCentre(undefined));
        SELECTED_CENTRES.delete();
      }
    }
  }, [selectedCentre, centreList]);

  useEffect(() => {
    dispatch(
      getAllCentresAsync({
        status: USER_STATUS.ACTIVE,
        userType: CHAT_GROUP_TYPE.USER,
      }),
    );
    centerRefresh();
  }, [selectedCentre]);

  // this function for adding the all table to hover effect

  // var ellipsisCells = document.querySelectorAll(
  //   '.table-header-custom > tbody > tr > td',
  // );
  // var ellipsisThCells = document.querySelectorAll(
  //   '.table-header-custom > thead > tr > th',
  // );

  // if (!pathname.includes('contentApproval') && ellipsisCells?.length) {
  //   for (var i = 0; i < ellipsisCells.length; i++) {
  //     // getting all td and th tag element
  //     let cell = ellipsisCells[i];
  //     let thCell = ellipsisThCells[i];

  //     if (thCell?.textContent !== 'Actions') {
  //       //this will be detect any td tag element contains react select or normal select

  //       cell.addEventListener('mouseover', function () {
  //         this.title = this.textContent;
  //       });
  //     }
  //   }
  // }

  // this function for adding the all table to title attributes
  let ellipsisCells = document.querySelector('table');
  // getting all td and th tag element

  if (
    ellipsisCells &&
    !pathname.includes('contentApproval') &&
    ellipsisCells.classList.contains('table-header-custom')
  ) {
    let celltd = Array.from(ellipsisCells?.lastElementChild?.children);
    let cellth = Array.from(
      ellipsisCells?.firstElementChild?.firstElementChild?.children,
    );

    // this loop to set value to all td tag in title attributes
    celltd.forEach((item, index) => {
      Array.from(item?.children).forEach((inItem, inIndex) => {
        if (cellth[inIndex]?.textContent !== 'Actions') {
          inItem.setAttribute('data-th', cellth[inIndex]?.textContent);
          inItem.title = inItem?.textContent;
        }
      });
    });
  }

  return (
    <div className={styles.container}>
      <PermissionWrapper>
        <Header />
        <div
          className={classnames(
            'mb-1',
            'container',
            styles.content,
            isMobile && isIOS ? 'mobile-ios' : '',
          )}
        >
          {children}
        </div>
        <Footer />
        <LearningPathModal />
        <AiModalPopup />
        <ChatbotModal />
      </PermissionWrapper>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withAuthUser(Layout);
